module.exports = __webpack_public_path__ + "img/knue_detail.b92d3a24.jpg";